var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDolyameDrawerAdvantage2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.08,
    width: 32,
    height: 32,
    rx: 4,
    fill: "#6F99C6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4 16.0001C18.4 15.5582 18.7582 15.2001 19.2 15.2001C20.5219 15.2001 21.6 16.2782 21.6 17.6001C21.6 18.9219 20.5219 20.0001 19.2 20.0001C18.7582 20.0001 18.4 19.6419 18.4 19.2001C18.4 18.7582 18.7582 18.4001 19.2 18.4001C19.6382 18.4001 20 18.0382 20 17.6001C20 17.1619 19.6382 16.8001 19.2 16.8001C18.7582 16.8001 18.4 16.4419 18.4 16.0001Z",
    fill: "#6F99C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4667 20.8V11.2C23.4667 10.6109 22.9891 10.1333 22.4 10.1333H9.60002C9.01091 10.1333 8.53335 10.6109 8.53335 11.2V20.8C8.53335 21.3891 9.01091 21.8667 9.60002 21.8667H22.4C22.9891 21.8667 23.4667 21.3891 23.4667 20.8ZM9.60002 8.53333C8.12726 8.53333 6.93335 9.72723 6.93335 11.2V20.8C6.93335 22.2728 8.12726 23.4667 9.60002 23.4667H22.4C23.8728 23.4667 25.0667 22.2728 25.0667 20.8V11.2C25.0667 9.72723 23.8728 8.53333 22.4 8.53333H9.60002Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.46668 12.5333C7.46668 12.0915 7.82486 11.7333 8.26668 11.7333L21.0667 11.7333C21.5085 11.7333 21.8667 12.0915 21.8667 12.5333C21.8667 12.9752 21.5085 13.3333 21.0667 13.3333L8.26668 13.3333C7.82486 13.3333 7.46668 12.9752 7.46668 12.5333Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDolyameDrawerAdvantage2);
export default __webpack_public_path__ + "static/media/dolyame-drawer_advantage-2.4a24ce60e25717b763e23cae54c329ec.svg";
export { ForwardRef as ReactComponent };